import { Loading } from "@dgs/core";
import { FC } from "react";
import { ArchivedCompanyBanner } from "../../companies/view/ArchivedCompanyBanner";
import { ArchivedCompanyOverview } from "../../companies/view/ArchivedCompanyOverview";
import { companyService } from "../../shared/api/companyService";
import { useDetailsPageEntityLoader } from "../../shared/hooks";
import { StyledSection } from "../../shared/view";

export const ArchivedCompanyViewPage: FC = () => {
	const { data, isLoading } = useDetailsPageEntityLoader(companyService);

	if (!data || isLoading) {
		return <Loading />;
	}

	return (
		<>
			{data.archivedByTenants.length > 0 && <ArchivedCompanyBanner id={data.id} />}
			<StyledSection color="content">
				<ArchivedCompanyOverview company={data} />
			</StyledSection>
		</>
	);
};
